<template>
  <div class="page-container content-430">
    <Form
      ref="searchForm"
      label-position="right"
      :label-width="0"
      class="search-list-430 search-wrapper-430"
    >
      <Row class="relative" type="flex" flex="end">
        <FormItem label="">
          <CascaderYearTerms
            ref="cascaderYearTerms"
            :has-default-value="true"
            :cache-year-terms="[null, null]"
            :placeholder="`请选择学期`"
            :clearable="true"
            @on-init="onYearTermInit"
          >
          </CascaderYearTerms>
        </FormItem>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="search-430" @click="handleReset">重置</Button>
      </Row>
    </Form>
    <div class="main-wrapper">
      <div
        class="table-title-special-430 flex justify-content_end"
        style="justify-content: end"
      >
        <Button
          type="primary"
          class="op-btn"
          @click="handleRemoveServe"
        >添加学期服务机构管理</Button>
      </div>
      <div class="table">
        <Table border :columns="tableColumns" :data="tableData">
          <template slot="orgNumber" slot-scope="{ row }">
            <span class="operate-btn-430" @click="checkDetial(4, row)">{{
              row.orgNumber
            }}</span>
          </template>
          <template slot="schoolNumber" slot-scope="{ row }">
            <span class="operate-btn-430" @click="checkDetial(1, row)">{{
              row.schoolNumber
            }}</span>
          </template>
          <template slot="action" slot-scope="{ row }">
            <span class="operate-btn-430" @click="copyFun(row)">复制</span>
            <span class="operate-btn-430" @click="editFun(row)">编辑</span>
            <span class="del-btn-430" @click="deleteFun(row)">删除</span>
            <span
              class="operate-btn-430"
              @click="handleToDetail(row)"
            >配置服务机构、学校</span>
          </template>
        </Table>
      </div>
      <div class="paging">
        <Page
          :total="pageInfo.total"
          show-total
          show-elevator
          :current="pageInfo.pageNum"
          :page-size="pageInfo.pageSize"
          @on-change="handlePageChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="modalRemoveShow"
      :title="
        opType == 1
          ? '添加学期服务机构'
          : opType == 2
            ? '编辑学期服务机构'
            : '复制学期服务机构'
      "
    >
      <div class="page_modal">
        <CascaderYearTerms
          ref="cascaderYearTermscAdd"
          :placeholder="`请选择学期`"
          :clearable="true"
          :cache-year-terms="initTerms"
          :has-default-value="true"
        ></CascaderYearTerms>
      </div>
      <div slot="footer">
        <Button type="text" @click="handleCancel()">取消</Button>
        <Button type="primary" @click="handleAdd()">确定</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalSelectRow"
      title="学期服务机构"
      :loading="loading"
      :width="750"
    >
      <div class="page_modal">
        <Table
          ref="selection"
          border
          :loading="loadingtable"
          :columns="checkType == 4 ? actOrgListColumns : actSchoolListColumns"
          :max-height="500"
          :data="actTableData"
        >
          <template slot="index" slot-scope="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
        </Table>
      </div>
      <div slot="footer">
        <Button type="primary" @click="handleSelectRow()">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import { mapState, mapGetters } from 'vuex';
import educationAdmin from '@/request/educationAdmin/index.js';
import { semesterOrgListColumns, actOrgListColumns, actSchoolListColumns } from '@/pages/assetsModules/manageData.js';
import EditButton from '@/pages/assetsModules/EditButton';

export default {
  name: 'ResourceEducationMage',
  components: {
    EditButton, CascaderYearTerms
  },
  filters: {
    InitCooperateState(v) {
      switch (v) {
        case 1:
          return '正常';
        case 2:
          return '已停止合作';
      }
    }
  },
  data() {
    return {
      loadingtable: false,
      actObj: {},
      // 1新增 2编辑 3复制
      opType: 1,
      initTerms: [null, null],
      // 查看具体数据类型 4机构 1学校
      checkType: 1,
      modalSelectRow: false,
      regionDataList: [],
      // 行内数据
      actTableData: [],
      pageInfo: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      tableColumns: [...semesterOrgListColumns],
      actOrgListColumns: [...actOrgListColumns],
      actSchoolListColumns: [...actSchoolListColumns],
      tableData: [],
      modalRemoveShow: false, // 弹窗显隐
      loading: false
    };
  },
  computed: { ...mapState(['userInfo']), ...mapGetters(['routeTitle']) },

  mounted() {
    this.getOrgList();
  },
  methods: {
    checkDetial(index, row) {
      this.checkType = index;
      this.modalSelectRow = true;
      const params = { pageNum: 1, orgType: index, pageSize: 100, bureauTermId: row.bureauTermId };
      this.loadingtable = true;
      educationAdmin.sysTermBureauOrgslistOrgApi(params).then((res) => {
        this.loadingtable = false;
        if (res.status === 200) {
          this.actTableData = res.message.list;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    handleSelectRow() {
      this.modalSelectRow = false;
    },
    handleAdd() {
      const yearTerms = this.$refs.cascaderYearTermscAdd.getResult();
      if (!yearTerms[0] || !yearTerms[1]) {
        this.$Message.error('请选择年度学期');
        return;
      }
      console.log('yearTermsyearTermsyearTerms', yearTerms);
      const params = {
        yearCode: yearTerms[0],
        termCode: yearTerms[1]
      };
      if (this.opType == 1) {
        params.educationBureauId = this.userInfo.orgId;
        educationAdmin.sysTermBureauOrgsAddApi(params).then(res => {
          if (res.status === 200) {
            this.modalRemoveShow = false;
            this.$Message.success('操作成功');
            this.getOrgList();
          } else {
            this.$Message.error(res.message);
          }
        });
      } else if (this.opType == 2) {
        params.bureauTermId = this.actObj.bureauTermId;
        educationAdmin.sysTermBureauOrgsUpdateApi(params).then(res => {
          console.log('ddddd', res);
          if (res.status === 200) {
            this.modalRemoveShow = false;
            this.$Message.success('操作成功');
            this.getOrgList();
          } else {
            this.$Message.error(res.message);
          }
        });
      } else if (this.opType == 3) {
        params.copyFrom = this.actObj.bureauTermId;
        params.educationBureauId = this.userInfo.orgId;
        educationAdmin.sysTermBureauOrgsAddApi(params).then(res => {
          if (res.status === 200) {
            this.modalRemoveShow = false;
            this.$Message.success('操作成功');
            this.getOrgList();
          } else {
            this.$Message.error(res.message);
          }
        });
      }
    },
    copyFun(row) {
      this.opType = 3;
      this.actObj = row;
      this.modalRemoveShow = true;
    },
    editFun(row) {
      this.actObj = row;
      this.opType = 2;
      console.log('row', row);
      const ar = [];
      ar[0] = row.yearCode,
      ar[1] = row.termCode + '';
      this.modalRemoveShow = true;
      this.initTerms = ar;
      this.$refs.cascaderYearTermscAdd.yearTerms = this.initTerms;
      // this.$refs.cascaderYearTermscAdd.getyearTermsListFun();

      // setTimeout(()=>{
      //   this.$refs.cascaderYearTermscAdd.getInitialData();
      // },1000)
      // this.$refs.cascaderYearTermscAdd.getyearTermsListFun
    },
    deleteFun() {
      this.$Message.error('学年学期已使用，不可删除');
    },
    onYearTermInit() {
      // this.handleSearch()
    },
    // 地区选择
    handelAreaChange(value, selectedData) {
      this.searchConds.area = value;
      this.searchConds.areaCode = value[value.length - 1];
    },
    // 重置
    handleReset() {
      this.$refs.cascaderYearTerms.handleClear();
      this.pageInfo.pageNum = 1;
      this.getOrgList();
    },
    // 查询
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.getOrgList();
    },
    // 分页
    handlePageChange(v) {
      this.pageInfo.pageNum = v;
      this.getOrgList();
    },
    // 服务机构详情
    handleToDetail(row, index) {
      this.$router.push({
        name: 'semester_orgdetail',
        query: { bureauTermId: row.bureauTermId, termName: row.termName, yearName: row.yearName }
      });
    },
    // 查询服务机构列表
    async getOrgList() {
      const { total, ...pageInfo } = this.pageInfo;
      const params = { ...pageInfo, educationBureauId: this.userInfo.orgId };
      const yearTerms = this.$refs.cascaderYearTerms.getResult();
      console.log('ff1f');
      params.yearCode = yearTerms[0];
      params.termCode = yearTerms[1];
      const res = await educationAdmin.sysTermBureauOrgsListApi(params);
      console.log('ff222f');

      if (res.status === 200) {
        console.log('ff333f');
        this.tableData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      } else {
        this.$Message.error(res.message);
      }
    },
    // 添加学期服务机构管理
    handleRemoveServe() {
      this.initTerms = [null, null];
      this.opType = 1;
      this.$refs.cascaderYearTermscAdd.yearTerms = [];
      this.modalRemoveShow = true;
    },
    handleCancel(name) {
      this.modalRemoveShow = false;
    },
    handleRuleReset(name) {
      this.$refs[name].resetFields();
    },
    handleOK(name) {
      this.modalRemoveShow = false;
      this.modalSelectRow = true;
    },
    handleSubmit(name) {
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common';

.page-container {
  height: 100%;
  box-sizing: border-box;
  padding: 16px;

  .green {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: green;
    margin-right: 5px;
    border-radius: 5px;
    margin-bottom: 2px;
  }

  .purple {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: purple;
    margin-right: 5px;
    border-radius: 5px;
    margin-bottom: 2px;
  }
}

.col-center {
  padding: 0 8px;
  margin-bottom: 8px;

  button + button {
    margin-left: 16px;
  }
}

.tabs-block {
  display: flex;
  margin: 8px 0 24px 0;
  border-bottom: 1px solid #ccc;

  .tab-item {
    padding: 16px 32px;
    border-bottom: 2px solid transparent;
    font-size: 16px;
  }

  .tab-item-active {
    color: #488ffa;
    border-bottom: 2px solid #488ffa;
  }

  .tab-item + .tab-item {
    margin-left: 16px;
  }
}
</style>
